module.exports = __webpack_public_path__ + "static/media/S3N2-1.2b366a38.svg";